module.exports = __webpack_public_path__ + "media/images/emblems/Waldar-aa56c7078fe9fd68d19a573cd39fc50a.png";